import moment from 'moment';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import ModalAx         from 'app/actions/company-admin/modal-slack-channel';
import SlackChannelsAx from 'app/actions/company-admin/slack-channels';
import Icon            from 'app/components/common/icon';
import Link            from 'app/components/common/link';
import Modal           from 'app/components/common/modal';
import StandardInput   from 'app/components/common/standard-input';
import config          from 'app/config';
import helpers         from 'app/helpers/slack';
import paths           from 'app/paths';
import CadminSlx       from 'app/selectors/company-admin/';
import ModalSlx        from 'app/selectors/company-admin/modal-slack-channel';
import EntitiesSlx     from 'app/selectors/entities';

class ModalSlackChannel extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      name: null,
    };

    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickCreate = this.onClickCreate.bind(this);
    this.onClickUnlink = this.onClickUnlink.bind(this);
    this.onClickJoin = this.onClickJoin.bind(this);
    this.onClickOpCreate = this.onClickOpCreate.bind(this);
    this.onClickOpFind = this.onClickOpFind.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
  }

  componentDidMount() {
    this.props.reset();
    if (this.props.defaultName) {
      this.setState({name: helpers.sanitizeChannelName(this.props.defaultName)});
    }
    if (this.props.id) {
      this.props.get(this.props.id);
    }
  }

  onCloseModal() {
    this.props.onClose();
  }

  onClickCreate() {
    const { create, onCreate, isPrivate, op } = this.props;
    const { name } = this.state;
    create(name, isPrivate, op, onCreate);
  }

  onClickUnlink(event) {
    event.preventDefault();
    const { unlink, onUnlink, slackChannel, unlinkPending } = this.props;
    if (unlinkPending) return;
    unlink(slackChannel.id, onUnlink);
  }

  onClickJoin() {
    const { join, slackChannel } = this.props;
    join(slackChannel.id);
  }

  onClickOpCreate() {
    this.props.setOp('create');
  }
  onClickOpFind() {
    this.props.setOp('find');
  }

  onChangeName(event) {
    const name = helpers.sanitizeChannelName(event.target.value);
    this.setState({name});
  }

  renderChannel() {
    const { company, id, slackChannel, createPending, createValidations, joinPending, joinAccountNotLinked, op } = this.props;
    if (id && !slackChannel) return <Icon.Loading className="loading" />;
    const { name } = this.state;
    const isCreate = op === 'create';
    const btnLabelCreate = createPending
      ? (isCreate ? 'Creating...' : 'Connecting...')
      : (isCreate ? 'Create' : 'Connect');
    const btnLabelJoin = joinPending ? 'Joining...' : 'Join Channel';
    const appHomeUrl = helpers.deepLinkAppHome(company.slackWorkspaceId);

    return slackChannel ? (<>
      <div className="ca-modal-schannel-channel">
        <Icon.Hash className="ca-modal-schannel-channel-icon" />
        <div className="ca-modal-schannel-channel-name">{slackChannel.name}</div>
        <button className="btn special slack" onClick={this.onClickJoin} disabled={joinPending}>{btnLabelJoin}</button>
      </div>
      {joinAccountNotLinked && (
        <p className="ca-modal-schannel-not-linked">Oops! Your slack account isn't connected yet. <a href={appHomeUrl} target="_blank">Connect My Slack Account</a></p>
      )}
    </>) : (
      <div className="ca-modal-schannel-input">
        <div className="ca-modal-schannel-input-tabs">
          <button onClick={this.onClickOpCreate} className={`ca-modal-schannel-input-tab ${isCreate ? 'active' : ''}`}>New Channel</button>
          <button onClick={this.onClickOpFind} className={`ca-modal-schannel-input-tab ${!isCreate ? 'active' : ''}`}>Existing Channel</button>
        </div>
        {!isCreate && (
          <p className="ca-modal-schannel-input-op-info"><strong>Step 1</strong><br />Go to the channel in Slack and add the Millie app to the channel by typing @millie and clicking 'Add to Channel' or 'Invite Them' when prompted.</p>
        )}
        {isCreate ? (
          <p className="ca-modal-schannel-input-op-desc">Create a new channel in Slack:</p>
        ) : (
          <p className="ca-modal-schannel-input-op-desc"><strong>Step 2</strong><br />Connect to an existing channel in Slack:</p>
        )}
        <div className="ca-modal-schannel-input-form">
          <StandardInput label="Channel Name" name="name" value={name || ''} onChange={this.onChangeName} icon={<Icon.Hash />} validations={createValidations} />
          <button className="btn special slack" onClick={this.onClickCreate} disabled={createPending}>{btnLabelCreate}</button>
        </div>
      </div>
    );
  }

  renderActions() {
    const { slackChannel, actions } = this.props;
    if (!actions) return null;
    return (
      <div className="ca-modal-schannel-actions">
        {actions}
      </div>
    );
  }

  renderBottom() {
    const { slackChannel, unlinkPending } = this.props;
    if (!slackChannel) return null;
    const btnLabel = unlinkPending ? 'Unlinking...' : 'Unlink Channel';
    return (
      <div className="ca-modal-schannel-bottom">
        <p>If you’d like to rename the channel, you can do this directly within Slack.</p>
        <a className="ca-modal-schannel-bottom-unlink" onClick={this.onClickUnlink}>{btnLabel}</a>
      </div>
    );
  }

  render() {
    const { company, title, subHeader } = this.props;

    return (
      <Modal className="ca-modal-schannel" onClose={this.onCloseModal}>
        <div className="ca-modal-schannel-header">
          <img src="/images/company-admin/slack-logo.png" alt="Slack" />
          <h1>{title}</h1>
        </div>
        {subHeader}
        {this.renderChannel()}
        {this.renderActions()}
        {this.renderBottom()}
      </Modal>
    );
  }

}

ModalSlackChannel.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUnlink: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string,
  slackChannel: PropTypes.object,
  isPrivate: PropTypes.bool,
  subHeader: PropTypes.node,
  defaultName: PropTypes.string,
  actions: PropTypes.node,
};

ModalSlackChannel.defaultProps = {
  isPrivate: false,
  subHeader: null,
};

const stateToProps = (state, ownProps) => ({
  company: CadminSlx.company(state),
  slackChannel: ownProps.slackChannel || EntitiesSlx.slackChannelById(state, ownProps.id),

  createPending: ModalSlx.createPending(state),
  createValidations: ModalSlx.createValidations(state),
  unlinkPending: ModalSlx.unlinkPending(state),
  joinPending: ModalSlx.joinPending(state),
  joinAccountNotLinked: ModalSlx.joinAccountNotLinked(state),
  op: ModalSlx.op(state),
});

const dispatchToProps = (dispatch) => ({
  get: (id) => dispatch(SlackChannelsAx.get(id)),
  reset: () => dispatch(ModalAx.reset()),
  setOp: (op) => dispatch(ModalAx.setOp(op)),
  create: (name, isPrivate, op, onCreate) => dispatch(ModalAx.create(name, isPrivate, op, onCreate)),
  unlink: (slackChannelId, onUnlink) => dispatch(ModalAx.unlink(slackChannelId, onUnlink)),
  join: (slackChannelId) => dispatch(ModalAx.join(slackChannelId)),
});

export default connect(stateToProps, dispatchToProps)(ModalSlackChannel);
